import React from 'react';
import { BarChart, Tooltip, XAxis, YAxis, Legend, Bar, ResponsiveContainer } from 'recharts';
  
const LCBarChart = ({ data = [], xaxisLabel}) => {
  if (data.length === 0) return null;
  const keys = data.length ? Object.keys(data[0]).filter(k => k !== xaxisLabel) : []
  const COLORS = ['#0a2463','#b0c4de'];
  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data}>
        <XAxis dataKey={xaxisLabel} />
        <YAxis />
        <Tooltip />
        <Legend />
        {keys.map((key, index) => (
          <Bar dataKey={key} fill={COLORS[index]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};
  

export default LCBarChart;